<template>
  <b-modal
    id="delete-account-modal"
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Delete')"
    :title="$t('myProfile.delete.account')"
    cancel-variant="outline-primary"
    centered
    ok-variant="danger"
    @ok="handleOk">
    <div class="mb-4">
      {{ $t('Delete.account.warning') }}
    </div>
  </b-modal>
</template>
<script>
import api from "../../services/api";

export default {
  name: "DeleteAccountModal",

  props: {
    user: Object
  },

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    async handleSubmit() {
      await api
        .delete(`/user/${this.user.id}`)
        .then(async response => {
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 4000,
              toaster: 'b-toaster-bottom-right',
              variant: "danger",
              solid: true,
            })
          }
        })
      this.$store.commit('setUnsavedChanges', false);
      await this.$store.dispatch('LogOut')
      location.reload()
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/DeleteAccountModal.vue